import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function index(){
  const spacer = document.getElementById('spacer')
  if(spacer){
    gsap.fromTo('.firstview .firstview__wrapper',
      {},
      {
        opacity: '0',
        scrollTrigger: {
          trigger: spacer,
          start: "top top",
          end: "bottom top",
          scrub: 1,
          once: false,
          //markers: true
        }
      }
    )
    gsap.fromTo('.firstview .firstview__title',
      {},
      {
        y: '-25%',
        opacity: 0,
        scrollTrigger: {
          trigger: spacer,
          start: "top top",
          end: "bottom top",
          scrub: 2,
          once: false,
          //markers: true
        }
      }
    )
    gsap.fromTo('.firstview .firstview__video',
      {},
      {
        scale: 1.2,
        scrollTrigger: {
          trigger: spacer,
          start: "top top",
          end: "bottom top",
          scrub: 3,
          once: false,
          //markers: true
        }
      }
    )


    const strong = document.querySelector('.firstview .firstview__title strong')
    const children = Array.from(strong.childNodes)
    const groups = [[]]
    let currentGroup = 0

    children.forEach(node => {
      if (node.nodeName === 'BR') {
        currentGroup++
        groups[currentGroup] = []
      } else if (node.nodeName === 'SPAN') {
        groups[currentGroup].push(node)
      }
    })


    gsap.utils.toArray(groups).forEach((el, index) => {
      const c = (index + 1) * 5 + '%'
      gsap.fromTo(el,
        {},
        {
          top: c,
          opacity: 0,
          scrollTrigger: {
            trigger: spacer,
            start: "top top",
            end: "bottom top",
            scrub: 2,
            once: false,
            //markers: true
          }
        }
      )  
    })
  }
  
}